import {
  BookOpen,
  Camera,
  CircleDashed,
  FileStack,
  FileText,
  Scale,
  StickyNote,
  type LucideIcon,
} from "lucide-react";
import type { KnowledgeSourceType } from "@gb/contracts";

/**
 * How each knowledge source is drawn.
 *
 * Here rather than in `brain-screen.tsx` so the detail screen does not have to
 * import the list screen to render one pill — which made a screen depend on its
 * sibling for a lookup table, and would eventually have been a cycle.
 */
export const SOURCE_ICONS: Record<KnowledgeSourceType, LucideIcon> = {
  manual: BookOpen,
  journal: FileText,
  decision: Scale,
  "project-doc": FileStack,
  upload: StickyNote,
  photo: Camera,
  other: CircleDashed,
};

export const SOURCE_STYLES: Record<KnowledgeSourceType, string> = {
  manual: "border-border bg-canvas text-ink-slate",
  journal: "border-brand/30 bg-brand/8 text-brand",
  decision: "border-warn/40 bg-warn/10 text-warn",
  "project-doc": "border-ok/40 bg-ok/10 text-ok",
  upload: "border-border bg-canvas text-ink-slate",
  photo: "border-brand/30 bg-brand/8 text-brand",
  other: "border-border bg-canvas text-muted",
};
